import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-white" data-id="element-93">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-94">
        <h2 className="text-4xl md:text-6xl font-bold text-slate-900 mb-6 tracking-tight" data-id="element-95">
          Ready to Leave Your <br className="hidden md:block" data-id="element-96" />
          Competitors Behind?
        </h2>

        <p className="text-xl text-slate-600 mb-10 max-w-2xl mx-auto" data-id="element-97">
          Peak season is starting NOW in Phoenix.
        </p>

        <div className="flex flex-col items-center gap-6" data-id="element-98">
          <a href="https://api.viridiaanalytics.com/widget/booking/hv5pIfS27zbJCMMGNnkJ" target="_blank" rel="noopener noreferrer" className="px-10 py-5 bg-orange-600 hover:bg-orange-500 text-white text-xl font-bold rounded-full transition-all shadow-xl hover:shadow-orange-500/30 transform hover:scale-105 flex items-center gap-3" data-id="element-99">
            Schedule Your Free Strategy Call
            <ArrowRight className="w-6 h-6" data-id="element-100" />
          </a>

          <div className="space-y-2" data-id="element-101">
            <p className="text-sm font-medium text-slate-500 bg-slate-50 px-4 py-2 rounded-full border border-slate-100 inline-block" data-id="element-102">
              🔥 Limited availability for January 2026 onboarding
            </p>
            <p className="text-xs text-slate-400" data-id="element-103">
              We only take 3 new clients per month to ensure quality
            </p>
          </div>
        </div>
      </div>
    </section>;
}